import Organisation from '@/models/Organisation';
import { Fund, ProductType, Strategy } from '@/modules/fund/types';
import { OrganisationUser } from '../types';

export interface IOrganisationState {
  orgNavbar: boolean;
  organisation?: Organisation;
  organisationUser: OrganisationUser;
  loader: boolean;
}

export const OrganisationState: IOrganisationState = {
  orgNavbar: false,
  organisation: undefined,
  organisationUser: {},
  loader: false
};
